export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "deliveryNote": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bons de livraison"])},
        "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En cours"])},
        "delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terminés"])}
      }
    }
  })
}
